import Modal, { DEFAULT_OPTIONS } from 'CoreComponents/modal';
import IntlTelInput from 'intl-tel-input';

document.querySelectorAll(`.${DEFAULT_OPTIONS['className']['MODAL']}`).forEach(modal => {
  if (!modal.classList.contains('modal-video')) {
    new Modal(modal);
  }
});

class CustomerDetail {
  constructor() {
    this._setup();
  }

  _setup() {
    this.telInput = document.querySelector('#user_phone_number');
    this.dialCodeInput = document.querySelector('#user_dial_code');
    if (!this.telInput) { return; }

    this.iti = IntlTelInput(this.telInput, {
      initialCountry: 'th',
      utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.0/js/utils.js'
    });

    const form = this.telInput.closest('form');
    if (form) {
      form.addEventListener('submit', (event) => this.submitHandler(event));
    }

    // Clear validation error when user types
    this.telInput.addEventListener('input', () => {
      this.telInput.setCustomValidity('');
    });
  }

  submitHandler(event) {
    if (this.telInput.value.trim() !== '') {
      if (!this.iti.isValidNumber()) {
        event.preventDefault();
        this.telInput.setCustomValidity('Please enter a valid phone number.');
        this.telInput.reportValidity();
        return;
      }
      this.telInput.setCustomValidity('');

      const dialCode = this.iti.getSelectedCountryData().dialCode;
      this.telInput.value = `0${this.iti.getNumber().replace(`+${dialCode}`, '')}`;
      if (this.dialCodeInput) {
        this.dialCodeInput.value = dialCode;
      }
    }
  }
}

if (document.querySelector('#user_phone_number')) {
  new CustomerDetail();
}
